import HCRender from "aldoo-ra/HelpCenter/hc-render"
import Typography from "aldoo-ra/Typography"
import { ChevronRightIcon } from "@heroicons/react/24/outline"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const CategoryContent = ({ category, onNavigate }) => {
  const texts = TextBundle({ id: "help-center" })
  const HCCategoryNote = HCRender.getFragment("HCCategoryNote")

  if (!category) return null

  const title = category.content?.name || "Category"
  const description = category.content?.description || ""
  const articles = category.content?.articles || []
  const subcategories = category.content?.categories || []
  const notes = category.content?.notes || []
  const categoryPath = category.path || ""

  const topNotes = notes.filter((note) => note.renderas?.startsWith("top_"))
  const bottomNotes = notes.filter(
    (note) => note.renderas?.startsWith("bottom_") || !note.renderas
  )

  const handleArticleClick = (article) => {
    if (onNavigate) onNavigate("article", article.slug, categoryPath)
  }

  const handleCategoryClick = (subcategory) => {
    if (onNavigate) {
      const path = categoryPath
        ? `${categoryPath}/${subcategory.slug}`
        : subcategory.slug
      onNavigate("category", path)
    }
  }

  // a real link (href) for crawlers and new tabs; a click stays in the help center
  const renderCard = (title, href, onClick) => (
    <a
      href={href}
      className="h-[116px] flex items-center justify-between gap-6 bg-paper border border-bordered rounded-[30px] cursor-pointer hover:border-secondary hover:shadow-soft_lg transition-shadow p-5 xl:p-[30px] no-underline"
      onClick={(e) => { e.preventDefault(); onClick() }}
    >
      <Typography variant="body1_medium" className="my-0">{title}</Typography>
      <div className="w-[30px] h-[30px] flex items-center justify-center flex-shrink-0 bg-primary_lt rounded-full ml-auto">
        <ChevronRightIcon className="w-[18px] h-[18px] text-text stroke-2" />
      </div>
    </a>
  )

  return (
    <div className="w-full lg:w-[620px] xl:w-[752px]">
      <Typography variant="h2" component="h1" className="mb-[30px]">{title}</Typography>

      {HCCategoryNote && topNotes.map((note) => (
        <HCCategoryNote key={note._id} note={note} />
      ))}

      {description && <div className="text-text_secondary mb-8">{description}</div>}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-14">
        {articles.map((article) => (
          <div key={article._id || article.slug}>
            {renderCard(
              article.label || article.name || article.title,
              categoryPath
                ? `/help-center/category/${categoryPath}/article/${article.slug}`
                : `/help-center/article/${article.slug}`,
              () => handleArticleClick(article)
            )}
          </div>
        ))}
        {subcategories.map((subcategory) => (
          <div key={subcategory._id || subcategory.slug}>
            {renderCard(
              subcategory.label || subcategory.name || subcategory.title,
              `/help-center/category/${categoryPath ? `${categoryPath}/` : ""}${subcategory.slug}`,
              () => handleCategoryClick(subcategory)
            )}
          </div>
        ))}
      </div>

      {subcategories.length === 0 && articles.length === 0 && (
        <div className="text-center py-10">
          <Typography variant="h3" className="text-text">
            {texts?.empty_category_title || "No content found"}
          </Typography>
          <Typography variant="body1_dim">
            {texts?.empty_category_subtitle || "This category does not contain any articles or subcategories."}
          </Typography>
        </div>
      )}

      {HCCategoryNote && bottomNotes.map((note) => (
        <HCCategoryNote key={note._id} note={note} />
      ))}
    </div>
  )
}

export default CategoryContent
